import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import styleW from './WhatsApp.module.css';

const WhatsappFloatButton = () => {
    const handleClick = () => {
        window.open('https://wa.me/958533331', '_blank');
    };

    return (
        <div className={styleW.whatsappFloatButton} onClick={handleClick}>
            <FontAwesomeIcon icon={faWhatsapp} size="2x" />
        </div>
    );
};

export default WhatsappFloatButton;
